<sdc-bo-dialog
  headerTitle="Are you sure you want to delete all these redis keys?"
  [styleClass]="['variant-prominent-title']">
  <div class="content-wrapper">
    <sdc-info-grid
      [items]="[{ label: 'Keys', value: keys().join(', ') }]"
      [columns]="1" />
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button variant="destructive" (onClick)="onConfirm()">
      Permanently delete
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
